import React from "react";
import ScrollToTop from "../components/ScrollToTop.js";
import Signin from "../components/Signin.js";

const SigninPage = () => {
  return (
    <>
      <ScrollToTop />
      <Signin />
    </>
  );
};

export default SigninPage;
